import React, { useState, useEffect, useRef } from "react";
import { CartState } from "../Context/Context";
import "../Styles/Cart.css";
import {  MdClear } from "react-icons/md";
import { Link } from "react-router-dom";

import { AiFillPlusCircle, AiFillMinusCircle } from "react-icons/ai";

let useClickOutside = (handler) => {
  let domNode = useRef();

  useEffect(() => {
    let maybeHandler = (event) => {
      if (!domNode.current.contains(event.target)) {
        handler();
      }
    };

    document.addEventListener("mousedown", maybeHandler);

    return () => {
      document.removeEventListener("mousedown", maybeHandler);
    };
  });

  return domNode;
};

export default function Cart(props) {
  const {
    state: { cart },
    dispatch,
  } = CartState();
  const [error, setError] = useState('Stock Out')

  const [total, setTotal] = useState();

  useEffect(() => {
    setTotal(cart.reduce((acc, curr) => acc + curr.specialprice * curr.qty, 0));
  }, [cart]);

  let domNode = useClickOutside(() => {
    props.setshowCart(false);
  });

  return (
    <div
      className="cart"
      style={{
        transform: props.showCart ? "translateX(0)" : "translateX(100%)",
      }}
      ref={domNode}
    >
      <div className="cart-header">
        <div className="cart-title">
          <h3>Your Bag</h3>
          <MdClear
            style={{ fontSize: "34px", cursor: "pointer" }}
            onClick={() => props.setshowCart(false)}
          />
        </div>

        <div className="cart-body">
          {cart.length > 0 ? (
            <>
              {cart.map((item) => (
                <div className="cart-item" key={item.id}>
                  <img src={item.image} alt={item.title} />

                  <div className="cart-item-details">
                    <p>{item.title}</p>
                   <p >Price : ₹ {item.specialprice}</p>
                   <p >Size : {item.size}</p>
                    <div className="qty-title">Qty :</div>
                    <div className="item-btn">
                      <div className="qty-btn">
                        <button
                          className="icon-btn"
                          onClick={() =>
                            dispatch({
                              type: "CHANGE_CART_QTY",
                              payload: {
                                id: item.id,
                                qty: item.qty - 1,
                              },
                            })
                          }
                        >
                          -
                        </button>
                        <span>{item.qty}</span>
                        <button
                        // style={{cursor:'none'}}
                        disabled={item.qty===parseInt(item.stock)}
                          onClick={() =>
                            dispatch({
                              type: "CHANGE_CART_QTY",
                              payload: {
                                id: item.id,
                                qty: item.qty + 1,
                              },
                            })
                          }
                          className="icon-btn"
                        >+</button>
                      </div>

                    </div>
                    {item.qty===parseInt(item.stock)&& <p style={{color:'red',fontSize:'12px'}}>Only {item.stock} Available</p>}
                    <div className="delete-btn my-3">
                     
                     <button
                       type="button"
                       className="btn btn-outline-danger btn-sm"
                       onClick={() =>
                         dispatch({
                           type: "REMOVE_FROM_CART",
                           payload: item,
                         })
                       }
                     >
                       Remove
                     </button>
                   </div>
                  </div>
                </div>
              ))}
            </>
          ) : (
            <p>No items in your cart</p>
          )}
        </div>
      </div>

      <div className="cart-footer">
        <div className="total-price">
          <span>Total Price : {total}</span>
        </div>

        <div className="checkout-btn">
          {total === 0 ? (
            <button disabled>CHECKOUT</button>
          ) : (
            <Link to="/checkout">
              <button onClick={() => props.setshowCart(false)}>CHECKOUT</button>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
